import { render, staticRenderFns } from "./MatterEvidenceDetectionForm.vue?vue&type=template&id=6c308db8&"
import script from "./MatterEvidenceDetectionForm.vue?vue&type=script&lang=js&"
export * from "./MatterEvidenceDetectionForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterEvidenceDetectionForm.vue?vue&type=style&index=0&id=6c308db8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports